module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._b({
    staticClass: "btn-list",
    class: [_vm.bemFacet]
  }, 'div', _vm.cmsEditHelperAttrs, false), [(_vm.content.title) ? _c('h2', {
    staticClass: "btn-list--title",
    domProps: {
      "innerHTML": _vm._s(_vm.content.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-list--buttons"
  }, [_c('ul', {
    staticClass: "u-reset grid--row btn-list--row"
  }, _vm._l((_vm.buttons), function(button, buttonIdx) {
    return _c('li', {
      staticClass: "grid--col btn-list--col"
    }, [_c(button.type, {
      tag: "component",
      staticClass: "btn-list--button",
      attrs: {
        "facet": _vm.content.facet,
        "plugin": button
      }
    })], 1)
  }))]), _vm._v(" "), (_vm.content.link) ? _c('router-link', {
    staticClass: "btn-list--link",
    attrs: {
      "to": _vm.content.link.path
    },
    domProps: {
      "textContent": _vm._s(_vm.content.link.label)
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a1b8fa12", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1b8fa12","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/btn-list/index.vue
// module id = 575
// module chunks = 7